let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aN17F")).then(() => parcelRequire('3jj6g'));